import { useLocation } from "react-router-dom";

const paths = ["/products"];

const excludedParams = ["gid", 'unit'];

const useBannerBlurb = (): boolean => {
  const {pathname, search} = useLocation();
  
  if (paths.includes(pathname)) {
    const params = new URLSearchParams(search);
    const keys = Array.from(params.keys());
    const includesAnyExcludedParams = keys.some((key) =>
      excludedParams.includes(key)
    );
    if (includesAnyExcludedParams) {
      return false;
    }
    return true;
  }
  return false;

};

export default useBannerBlurb;
